/**
 * @ngdoc object
 * @name theme.base.controller:AlTopSearchCtrl
 *
 * @description
 *
 */

class AlTopSearchCtrl {
    constructor(Contacts, $element, $scope, $state, Acl, Users, $timeout) {
        this.company = Users.state.company;
        this.store = Contacts.reset({
            persist: false,
            listview: 'AlTopSearchListView',
            visible: [
                'full_name',
                'profile_image',
                'id',
                'code',
                'company_name',
                'customer_number'
            ],
            columns: [
                {
                    key: 'full_name',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'profile_image',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'id',
                    type: 'integer',
                    visible: true
                },
                {
                    key: 'code',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'company_name',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'customer_number',
                    type: 'integer',
                    visible: true
                }
            ]
        });
        this.store.commit('setPagination', {perPage: 8});

        this.element = $element;
        this.scope = $scope;
        this.state = $state;
        this.acl = Acl;
        this.timeout = $timeout;

        this.dropdownShown = false;
        this.loading = true;
        this.timer = 0;
        this.currentActiveIndex = 0;
        this.searchValue = '';
        this.results = [];
        this.input = null;
        this.showMobSearch = false;
        this.onCloseTriggered = () => {
        };

        this.dropdownTrigger = null;

        this.initWatchers();
        this.jQueryDocument = $(document);

        $scope.$on('dropdown-opened', () => {
            this.focusSearch()
        })
    }

    $postLink() {
        this._initKeypressEvents();
    }

    $onDestroy() {
        this._destroyKeypressEvents();
    }

    fireCloseTrigger() {
        this.onCloseTriggered();
    }

    setCurrentActiveIndex(newIndex) {
        this.currentActiveIndex = newIndex;
        this.scope.$applyAsync();
    }

    _destroyKeypressEvents() {
        this.jQueryDocument.off('keydown', this._handleKeyPressEvent)
        this.jQueryDocument.off('keydown', this._handleFocusSearchTrigger)
    }

    _initKeypressEvents() {
        const input = angular.element('#al-quick-search-input');

        if (input && input.length > 0) {
            this.input = input;
            this.jQueryDocument.on('keydown', this._handleKeyPressEvent.bind(this));
        } else {
            this.timeout(() => {
                this._initKeypressEvents();
            }, 100);
        }

        const dropdownTrigger = this.element.find('.quick-search-dropdown-toggle');

        // if (dropdownTrigger && dropdownTrigger.length > 0) {
        //     this.dropdownTrigger = dropdownTrigger;
        //     this.jQueryDocument.on('keydown', this._handleFocusSearchTrigger.bind(this));
        // }
    }

    _handleFocusSearchTrigger(e) {
        if (navigator.platform.indexOf('Mac') !== -1) {
            if (e.metaKey && e.which === 70) {
                e.preventDefault();
                this.focusSearch();
            }
        } else {
            if (e.ctrlKey && e.which === 70) {
                e.preventDefault();
                this.focusSearch();
            }
        }
    }

    _handleKeyPressEvent(e) {
        if (
            this.results.length <= 0
            || !this.dropdownShown
        ) {
            return;
        }

        switch (e.which) {
            case 38: // up
                e.preventDefault();
                if (this.currentActiveIndex > 0) {
                    this.setCurrentActiveIndex(this.currentActiveIndex - 1);
                } else {
                    this.setCurrentActiveIndex(this.results.length - 1);
                }
                break;
            case 40: // down
                e.preventDefault();
                if (this.currentActiveIndex < this.results.length - 1) {
                    this.setCurrentActiveIndex(this.currentActiveIndex + 1);
                } else {
                    this.setCurrentActiveIndex(0);
                }
                break;
            case 13: // enter
                e.preventDefault();
                this.goToContact(this.results[this.currentActiveIndex]);
                break;
        }
    }

    focusSearch() {
        const dropdownSheet = this.element.find('.dropdown-sheet');

        if (!dropdownSheet.hasClass('open')) {
            this.dropdownTrigger.trigger('click')
        }

        this.input.focus();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.searchValue;
        }, () => {
            this.doSearch();
        })
    }

    doSearch() {
        if (!this.dropdownShown) {
            this.startSearch();
        }
        if (this.searchValue === '') {
            clearTimeout(this.timer);
            this.quitSearch();
        } else {
            this.loading = true;
            this.delayedSearch(() => {
                this.refreshResults();
            }, 400);
        }
    }

    refreshResults() {
        this.results = [];
        this.store.commit('setKeyword', this.searchValue);
        this.store.dispatch('getData').then(() => {
            this.currentActiveIndex = 0;
            this.results = this.store.state.data;
            this.loading = false;
        });
    }

    startSearch() {
        this.timer = 0;
        this.dropdownShown = true;
    }

    quitSearch() {
        // this.showMobSearch = false;
        this.searchValue = '';
        this.dropdownShown = false;
        this.applyAsync();
    }

    delayedSearch(callback, ms) {
        clearTimeout(this.timer);
        this.timer = setTimeout(callback, ms);
    }

    goToContact(contact) {
        this.quitSearch();
        if (this.input) {
            this.input.blur();
        }
        this.state.go(
            'app.contacts.details.overview',
            {
                id: contact.id,
                contact: null
            },
            {
                reload: true
            });
    }

    applyAsync() {
        this.scope.$evalAsync();
    }
}

AlTopSearchCtrl.$inject = [
    'Contacts',
    '$element',
    '$scope',
    '$state',
    'Acl',
    'Users',
    '$timeout'
];

angular
    .module('festzelt-os.theme.festzelt-os')
    .controller('AlTopSearchCtrl',
        AlTopSearchCtrl
    );




// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/components/al-top-search/controller.js